export function postMessageToParent<T>(message: T, parentOrigin: string) {
    if (!parentOrigin) {
        throw new Error('Unable to send message to parent window without knowing ist origin!');
    }
    window.parent.postMessage(message, parentOrigin);
}

